<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-23 13:54:22
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-09-24 11:27:18
 * @FilePath: /wemeet-admin-new/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/enterprise_home_page/components/MainPageIntroduction.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <!-- v-if="detail.newsIntroduction && detail.newsIntroduction != '' && photoList.length > 0 && detail.isHideBaseInfo" -->
  <div :class="customClass" class="bg-white d-flex flex-column pb-12  br-12 pl-12 pr-6 pt-15 border-box text-left" >
    <div class="cor-262626 fz-17 fw-7 mr-6" v-if="detail.newsIntroduction && detail.newsIntroduction != ''">{{$t('lang.t254')}}</div>
    <!-- 文字内容 -->
    <div class="cor-262626 fz-16 mt-14 text-wrap mr-6 descBox">
      <template v-for="(item, index) in detail.newsIntroduction">
        <p v-if="item.type == 'content'">{{item.content}}</p>
        <img :src="item.content" v-if="item.type == 'img'" @click="previewUrl(item.content, 0)" alt="" class="img">
        <p v-if="item.type == 'title'" class="title">{{item.content}}</p>
      </template>
    </div>
    <template v-if="photoList.length > 0">
      <div class="cor-262626 fz-17 fw-7 mr-6 mt-10">{{$t('lang.t255')}}</div>

      <!-- 视频图片 -->
      <div class="d-flex flex-wrap mt-9">
        <div class="col-6 pr-6 pb-6 border-box" v-for="(item, index) in photoList" :key="index">
          <img @click="previewUrl(item.previewUrl, index)" class=" w-full d-block br-10" v-if="item.fileType == 1" :src="item.previewUrl" alt="" style="height: 157px;object-fit:cover;">
          <video x5-video-player-type="h5" class=" w-full d-block br-10" :src="item.previewUrl" controls v-if="item.fileType == 3" style="height: 157px;object-fit: cover;"></video>
        </div>
      </div>
    </template>

    <div v-if="detail.isHideBaseInfo">
      <div class="cor-262626 fz-17 fw-7 mr-6 mt-10">{{$t('lang.t256')}}</div>
      <!-- 文字内容 -->
      <div class="d-flex a-start mt-20 fz-14" v-if="detail.legalRepresentative">
        <div class="cor-9E9E9E text-nowrap">{{$t('lang.t256')}}:</div>
        <div class="cor-595959">{{detail.legalRepresentative  || ''}}</div>
      </div>
      <div class="d-flex a-start mt-20 fz-14" v-if="detail.registeredFund">
        <div class="cor-9E9E9E text-nowrap">{{$t('lang.t257')}}:</div>
        <div class="cor-595959">{{detail.registeredFund || ''}}</div>
      </div>
      <div class="d-flex a-start mt-20 fz-14" v-if="detail.establishmentDate">
        <div class="cor-9E9E9E text-nowrap">{{$t('lang.t258')}}:</div>
        <div class="cor-595959">{{detail.establishmentDate | filterForamatDate}}</div>
      </div>
      <div class="d-flex a-start mt-20 fz-14" v-if="detail.registeredAddress">
        <div class="cor-9E9E9E text-nowrap">{{$t('lang.t259')}}:</div>
        <div class="cor-595959">{{detail.registeredAddress || ''}}</div>
      </div>
    </div>

  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import wmtDate from '@/utils/date.js'
export default {
  name: 'MainPageIntroduction',
  props: {
    customClass: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Overview',
    },
    detail: {
      type: Object,
      default: {},
    },
    photoList: {
      type: Array,
      default: [],
    },
  },
  components: {},
  data() {
    return {}
  },
  filters: {
    filterForamatDate(val) {
      if (val) {
        return wmtDate.fromatDate('yyyy-MM-dd', new Date(val))
      } else {
        return ''
      }
    },
  },
  methods: {
    previewUrl(index) {
      let url = this.photoList
        .map((v) => {
          return v.fileType == 1 ? v.previewUrl : ''
        })
        .filter((v) => v != '')
      ImagePreview({
        images: url,
        index: index,
        closeable: true,
      })
    },
  },
  mounted() {},
}
</script>


<style lang="less" scoped>
.descBox {
  width: 100%;
  height: 100%;
  .img {
    width: 100%;
    height: 100%;
  }
  .title {
    position: relative;
    padding-left: 10px;
    &::before {
      content: '';
      position: absolute;
      top: 15%;
      left: 0;
      width: 5px;
      height: 15px;
      background: #000;
    }
  }
}
</style>